import React from "react";
import LegalLayout, { LegalH2, LegalP, LegalUL } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      testId="terms-page"
      overline="The Fine Print"
      title="Terms & Conditions"
      updated="February 2026"
    >
      <LegalP>
        Welcome to MileForge. By accessing, browsing, or purchasing from mileforge.in
        (the "Website") you agree to be legally bound by these Terms & Conditions.
        Please read them carefully before placing an order.
      </LegalP>

      <LegalH2>1. About MileForge</LegalH2>
      <LegalP>
        MileForge is an adventure motorcycle lifestyle brand owned and operated by
        <strong> Touring Craft &amp; Riders Cafe</strong> — a proprietorship firm registered in
        Chennai, Tamil Nadu, India (GSTIN: <strong>33AIUPC4644A1ZL</strong>). We sell premium
        riding gear, apparel, moto essentials and maintenance products online across India.
        All references to "we", "us", "our" refer to MileForge / Touring Craft &amp; Riders Cafe.
      </LegalP>

      <LegalH2>2. Eligibility</LegalH2>
      <LegalP>
        You must be at least 18 years of age and legally competent under Indian law to enter into a
        contract in order to purchase from the Website. By placing an order you confirm that you meet
        these requirements.
      </LegalP>

      <LegalH2>3. Products & Pricing</LegalH2>
      <LegalUL>
        <li>All prices are listed in Indian Rupees (INR) and are inclusive of applicable taxes unless stated otherwise.</li>
        <li>We reserve the right to modify prices, product descriptions, and availability at any time without prior notice.</li>
        <li>While we take reasonable care to ensure product images and colours are accurate, minor variations may occur due to screen/device differences.</li>
        <li>Stock is limited. An order is only confirmed once payment is successfully received and confirmed via email.</li>
      </LegalUL>

      <LegalH2>4. Orders & Payment</LegalH2>
      <LegalP>
        Payments are processed securely by <strong>Cashfree Payments India Pvt. Ltd.</strong> — a
        payment aggregator authorised by the Reserve Bank of India. Your card, UPI, or netbanking
        credentials are never stored on our servers. We reserve the right to cancel or refuse any
        order for reasons including but not limited to: pricing errors, stock unavailability,
        suspected fraud, or violation of these terms.
      </LegalP>

      <LegalH2>5. Shipping & Delivery</LegalH2>
      <LegalP>
        Please refer to our <a href="/shipping-policy" className="text-[#D96A1B] hover:underline">Shipping Policy</a>
        {" "}for detailed information on delivery timelines, charges, and coverage.
      </LegalP>

      <LegalH2>6. Returns, Refunds & Cancellation</LegalH2>
      <LegalP>
        Please refer to our <a href="/refund-policy" className="text-[#D96A1B] hover:underline">Refunds & Cancellation Policy</a>
        {" "}for detailed information.
      </LegalP>

      <LegalH2>7. Intellectual Property</LegalH2>
      <LegalP>
        All content on the Website — including logos, product photography, copy, design, code, and
        the "MileForge" and "Touring Craft" names — is the exclusive property of MileForge / Touring Craft
        and is protected by Indian and international copyright and trademark laws. No part may be
        reproduced without prior written consent.
      </LegalP>

      <LegalH2>8. User Accounts</LegalH2>
      <LegalUL>
        <li>You are responsible for maintaining the confidentiality of your account and password.</li>
        <li>You agree to accept responsibility for all activities that occur under your account.</li>
        <li>We reserve the right to suspend or terminate accounts that violate these terms.</li>
      </LegalUL>

      <LegalH2>9. Prohibited Use</LegalH2>
      <LegalP>
        You may not use the Website to conduct any unlawful activity, distribute malware, misrepresent
        your identity, scrape content, or interfere with the operation of the site.
      </LegalP>

      <LegalH2>10. Limitation of Liability</LegalH2>
      <LegalP>
        To the fullest extent permitted by law, MileForge shall not be liable for any indirect,
        incidental, special, or consequential damages arising from the use of our products or Website.
        Our maximum aggregate liability shall not exceed the value of the order in question.
      </LegalP>

      <LegalH2>11. Governing Law & Jurisdiction</LegalH2>
      <LegalP>
        These Terms are governed by the laws of India. Any disputes arising out of or in connection
        with these Terms shall be subject to the exclusive jurisdiction of the courts of Chennai,
        Tamil Nadu, India.
      </LegalP>

      <LegalH2>12. Changes to These Terms</LegalH2>
      <LegalP>
        We may update these Terms from time to time. The updated version will be posted on this page
        with the "Last updated" date revised. Continued use of the Website after any change constitutes
        your acceptance of the revised Terms.
      </LegalP>

      <LegalH2>13. Contact Us</LegalH2>
      <LegalP>
        For any questions about these Terms, write to us at
        {" "}<a href="mailto:hello@mileforge.in" className="text-[#D96A1B] hover:underline">hello@mileforge.in</a>
        {" "}or call <a href="tel:+919884041979" className="text-[#D96A1B] hover:underline">+91 98840 41979</a>.
      </LegalP>
    </LegalLayout>
  );
}
